<template>
  <div>
    <div class="b-b  fs-18 bold" style="padding-bottom: 16px">
      设置
    </div>
    <div class="flex h-full" style="margin: 30px 80px 0">
      <div class=" h-full" style="width: 50%">

        <div class="fs-16 text-center" style="color: #333333;margin-bottom: 17px">
          <slot name="deptName">分类设置
          </slot>
        </div>

        <div class="w-full border o-y-auto" style="height: 428px">
          <div class=" flex a-center j-between b-b" style="padding: 18px 16px 10px">
           <span class="fs-14 d-block m-r-6"><slot name="dept">分类
        </slot></span>
            <div @click="onAddClassify" class="flex a-center" v-if="hideClassify">
              <img alt="" src="../../assets/common/ic_add.png"
                   style="width: 16px;height: 16px;margin-right: 8px">
              <span class="fs-14" style="color: #0652DD">添加</span>
            </div>
          </div>
          <div>
            <ul class="p-t-10">
              <li :class="{'active': checkedClassifyId === item.id}" :key="index"
                  @click="onClassSelect(item)"
                  class="w-full p-h-15 lh-40 h-40 liHover flex a-center j-between"
                  v-for="(item,index) in classifyDatas">
                <span v-if="item.id !== valueId">{{ item.name }}</span>
                <Input @click.stop @on-blur="redactClassify(item)" autofocus class="inputBoder" ref="classedit"
                       style="width: 200px"
                       v-model="item.name "
                       v-show="item.id === valueId"></Input>

                <div :class="{'selectHover1':checkedClassifyId === item.id}" class="selectHover d-none">
                  <img @click.stop="onChangeValue(item,index)" alt="" class="w-15 h-15 m-r-10"
                       src="../../assets/common/ic-edit@2x.png" v-if="hideClassify">
                  <img @click.stop="deleteClassify(item)" alt="" class="w-15 h-15"
                       src="../../assets/common/ic_shanchu_class@2x.png" v-if="hideClassify">
                </div>
              </li>
              <div class="w-full p-h-15 lh-40 h-40 " style=" background: #EDF3FF;" v-if="addClassifyShow">
                <Input @on-blur="addPicClassify()" class="inputBoder" ref="classAdd" v-model="addClassify"></Input>
              </div>
            </ul>
          </div>
        </div>
      </div>
      <div class=" h-full" style="width: 50%">
        <div class="fs-16 text-center" style="color: #333333;margin-bottom: 17px">
          <slot name="positionName">分组设置
          </slot>
        </div>
        <div class="w-full b-b b-r b-t o-y-auto" style="height: 428px">
          <div class=" flex a-center j-between b-b" style="padding: 18px 16px 10px">
            <span class="fs-14 d-block m-r-6"><slot name="positione">分组
        </slot></span>
            <div @click="onAddGroup" class="flex a-center">
              <img alt="" src="../../assets/common/ic_add.png"
                   style="width: 16px;height: 16px;margin-right: 8px">
              <span class="fs-14" style="color: #0652DD">添加</span>
            </div>
          </div>
          <div>
            <ul class="p-t-10">
              <li :class="{'active': checkedGroupId === item.id}" :key="index"
                  class="w-full p-h-15 lh-40 h-40 liHover flex a-center j-between"
                  v-for="(item,index) in groupLists ">
                <span v-if="item.id !== groupId1">{{ item.name }}</span>
                <Input @on-blur="redactGroups(item)" autofocus class="inputBoder" ref="groupedit" style="width: 200px"
                       v-model="item.name"
                       v-show="item.id === groupId1"></Input>

                <div :class="{'selectHover1':checkedGroupId === item.id}" class="selectHover d-none">
                  <img @click="onChangeGroup(item,index)" alt="" class="w-15 h-15 m-r-10"
                       src="../../assets/common/ic-edit@2x.png">
                  <img @click="deleteGroups(item)" alt="" class="w-15 h-15"
                       src="../../assets/common/ic-delete@2x.png">
                </div>
              </li>
              <div class="w-full p-h-15 lh-40 h-40 " style=" background: #EDF3FF;" v-if="addGroupShow">
                <Input @on-blur="addGroupsChange()" class="inputBoder" ref="gropAdd" v-model="addGroupes"></Input>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClassGroupSettingWidget',
  props: {
    ObjParams: {
      type: Object,
      default: () => {
        return {
          classifyDatas: [],
        }
      }
    },
    hideClassify: {
      type: Boolean,
      default: true
    },
    edit: Boolean,
    getGroupData: Function,
    classadd: Function,
    classchange: Function,
    addGroups: Function,
    deleteClass: Function,
    deleteGroup: Function,
    renameGroup: Function
  },
  data () {
    return {
      addClassifyShow: false,           //初始化分类显示
      classifyDatas: [],
      groupLists: [],
      addClassify: '',                  //新增分类初始化,
      addGroupShow: false,
      checkedClassifyId: '',
      checkedGroupId: '',
      valueId: '',                      //修改分类名称Id
      groupId1: '',
      addGroupes: ''

    }
  },
  watch: {
    edit: {
      handler (newValue) {
        if (newValue) {
          this.classifyDatas = this.ObjParams.classifyDatas.slice(1)
          if (this.classifyDatas && this.classifyDatas.length) {
            this.checkedClassifyId = this.classifyDatas[0].id
          }
        } else {
          this.classifyDatas = []
          this.groupLists = []
          this.checkedClassifyId = ''
        }
      },
      immediate: true
    },
    checkedClassifyId: {
      handler (newValue) {
        if (newValue) {
          if (this.getGroupData) {
            this.getGroupData(newValue).then(res => {
              this.groupLists = res.slice(1)
            })
          }
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    onAddClassify () {
      this.addClassify = ''
      this.addClassifyShow = true
      this.$nextTick(() => {
        this.$refs.classAdd.focus()
      })
    },
    redactClassify (data) {
      if (this.classchange) {
        this.classchange(data).then(res => {
          this.classifyDatas = res.slice(1)
          this.valueId = ''
        })
      }
    },
    addPicClassify () {
      if (!this.addClassify) {
        this.addClassifyShow = false
        return
      }
      if (this.classadd) {
        this.classadd(this.addClassify).then(res => {
          this.classifyDatas = res.slice(1)

          let end = this.classifyDatas[this.classifyDatas.length - 1]
          this.checkedClassifyId = end.id

          this.addClassify = ''
          this.addClassifyShow = false
        })
      }
    },
    onAddGroup () {
      if (this.checkedClassifyId) {
        this.addGroupes = ''
        this.addGroupShow = true
        this.$nextTick(() => {
          this.$refs.gropAdd.focus()
        })
      } else {
        this.$Message.warning('请先添加分类')
      }
    },
    addGroupsChange () {
      if (!this.addGroupes) {
        this.addGroupShow = false
        return
      }
      if (this.addGroups) {
        this.addGroups(this.checkedClassifyId, this.addGroupes).then(res => {
          this.groupLists = res.slice(1)
          this.addGroupShow = false
          this.addGroupes = ''
        })
      }
    },
    onChangeValue (item, index) {
      this.valueId = item.id
      this.$nextTick(() => {
        this.$refs.classedit[index].focus()
      })
    },
    deleteGroups (data) {
      if (this.deleteGroup) {
        this.deleteGroup(data).then(() => {
          this.getGroupData(this.checkedClassifyId).then(res => {
            this.groupLists = res.slice(1)
          })
        })
      }
    },
    onChangeGroup (item, index) {
      this.groupId1 = item.id
      this.$nextTick(() => {
        this.$refs.groupedit[index].focus()
      })
    },
    redactGroups (item) {
      if (this.renameGroup) {
        this.renameGroup(item, this.checkedClassifyId).then(() => {
          this.getGroupData(this.checkedClassifyId).then(res => {
            this.groupLists = res.slice(1)
            this.groupId1 = 0
          })
        })
      }
    },
    onClassSelect (item) {
      this.checkedClassifyId = item.id
    },
    deleteClassify (item) {
      if (this.deleteClass) {
        this.deleteClass(item).then(res => {
          this.classifyDatas = res.slice(1)
          if (this.checkedClassifyId === item.id && this.classifyDatas && this.classifyDatas.length) {
            this.checkedClassifyId = this.classifyDatas[0].id
          }
          if (!(this.classifyDatas && this.classifyDatas.length)) {
            this.groupLists = []
          }
        })
      }

    }
  }
}
</script>

<style lang="scss" scoped>
  .active {
    background: #EDF3FF;
    color: #0652DD;
  }
</style>
